module.exports = __webpack_public_path__ + "static/security4@2x-2d050fd21fe22ac5423f5a3a7a3b915a.png";